import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { firstValueFrom, race, timer } from 'rxjs';
import { ScannerEventStore } from '../scanner-event/scanner-event.store.service';

/**
 * Initializes assigned events and gates on app bootstrap
 * Loads events from API and implements auto-selection logic
 */
export function provideCheckInGatesInitializer(
  options = { timeoutMs: 5000 },
): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(async () => {
      const store = inject(ScannerEventStore);

      store.loadAssignedGates();

      const loaded$ = toObservable(store.isLoadAssignedGatesLoaded);
      const error$ = toObservable(store.loadAssignedGatesError);
      const timeout$ = timer(options.timeoutMs);

      await firstValueFrom(race(loaded$, error$, timeout$));

      return undefined;
    }),
  ]);
}
